<script>
    import {push, pop, replace} from 'svelte-spa-router'
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';
	import { springIn } from "svelte-helpers/spring-transitions";

	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	const modal = writable(null);
	let timeout_id;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('health_stats');

    // The params prop contains values matched from the URL
    export let params = {}

    let dash_token = params.t
	let mebot_id = params.id
    let type_id = params.type_id

    let result = null
    let mebot_img_url = null;
    let mebot_i = null;
    let watts_score = '';
    let steps = '';
    let explorer = '';
    let social = '';
    let hrv = '';
    let m1 = null;
    let m2 = null;
    let mebots = [];
	let liking = false;
	let liked = false;
	let waving = false;
	let ranking = '';
	let byline = '';
	let social_link = '';
	let invite_count = 0;
	let invite_bounty = 0;
	let copied = false;
	let battling = false;


	async function fetchLeaderboard () {
		const res = await fetch('https://api.forever.today/?method=get_mebot_leaderboard', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                type_id
            })
		})

        const json = await res.json()
        result = json
        //json.data.mebots.forEach((x, i) => console.log(x));
        mebots = json.data.mebots.slice(0, 9);
		byline = json.data.byline;
		social_link = json.data.social_link;
		invite_count = json.data.invite_count;
		invite_bounty = json.data.invite_bounty;
    }

    fetchLeaderboard()

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, SPRING_IN);
		return {
			duration: 50000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

	const displayMebotDetails = async (e) => {
		var i = Number(e.target.dataset.cardId)
		console.log(i);
		if (i >= 0) {
			liked = false;

			mebot_i = i;
			console.log(mebots[i])
			mebot_img_url = mebots[i].mebot_img_url;
			liked = mebots[i].is_liked;
		}
	};

	function doNothing() {
		console.log('do nothing');
		return;
	}

	async function waveHandMebot() {
		console.log('do nothing');

		waving = true;
		setTimeout(function(){ waving = false; }, 600);
		let mebot_id = mebots[mebot_i].id;

		if (mebot_id > 0) {
			const res = await fetch(
				"https://api.forever.today/?method=wave_mebot",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token,
						mebot_id
					}),
				}
			);
			const json = await res.json();
		}

		return;
	}

	async function battleMebot() {

		battling = true;
		setTimeout(function(){ battling = false; }, 300);
		await sleep(300);
		push('/battle/' + dash_token + '/' + mebot_id + '/' + mebots[mebot_i].id)
	}

	async function likeMebot() {
		console.log('do nothing');

		liking = true;
		setTimeout(function(){ liking = false; liked = true; }, 700);
		let mebot_id = mebots[mebot_i].id;

		if (mebot_id > 0) {

			mebots[mebot_i].is_liked = 1;
			const res = await fetch(
				"https://api.forever.today/?method=like_mebot",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token,
						mebot_id
					}),
				}
			);
			const json = await res.json();
		}

		return;
	}

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {
		displayMebotMessage(`
		<center>
		<br><br>
		<font color="lightblue">` + social_link + `</font><br><br>

		Mebot link copied to your clipboard<br><br>
		Share it with your friends and earn bounty ✨ ⬆️	
		<br><br>
		`, 20000, 'Ok!');
	}

	function copyError() {
		displayMebotMessage(`
		<center>
		<br><br>
		Share your Mebot link:<br><br>
		<input value="` + social_link + `"></input><br><br>
		Copy & share it with your friends to earn bounty ✨ ⬆️
		<br><br>
		`, 100000, 'Done');
	}

	function copySocial() {
		var copyText = document.getElementById("social_link");
		//alert("Copied the text: " + copyText.value);

		copyToClipboard(copyText.value)
			.then(() => copySuccess())
			.catch(() => copyError());

		copied = true;
			setTimeout(
				function() {
					copied = false;
				},
			300
		);
	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		clearTimeout(timeout_id);
		modal.set(null);
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}
</script>

<Header
	header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>
<center>
	{#if mebot_img_url}
	<table width=300px border=0>
		<tr>
			<td width="50px" valign=top> <br><div class="vitals2-grey text-glow-electric" style="white-space: nowrap; font-size: 12px;" on:click={ () => mebot_img_url = null }> &nbsp; &nbsp; ✖️ </div> </td>
			<td width=200px>
				<div in:animateIn style="user-select: none;" >
					<!--<div
						href="/#/move/{dash_token}/{m_id}"
						style="user-select: none;"
					>-->
						<div on:click={ doNothing }>
						<img style="user-select: none;"
							on:click={ () => mebot_img_url = null }
							src={mebot_img_url}
							width="230px"
							alt="meebot"
							class="no_tap_zoom"
						/>
						</div>
					<!--</div>-->
				</div>
			</td>
			<td width="100px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;">
				<br>
				{#if mebots[mebot_i].is_owner == 0 }
				<div class="controls" class:like-pulsing={ liking } on:click={ likeMebot }>
					{#if liked}
					🧡
					{:else}
					🤍
					{/if}
				</div>
				<div class="controls" class:hand-pulsing={ waving } on:click={ waveHandMebot }>
				👋
				</div>
				{#if mebots[mebot_i].class == 'Trainer' }
				<div class="controls" class:hand-pulsing={ battling } on:click={ battleMebot }>
					⚔️
				</div>
				{/if}
				{:else}
				<br>
				{/if}
			</td>
		</tr>
	</table>
	<table width=300px border=0>
		<br>
		<tr height=20px valign=bottom>
			<td width5=55px>&nbsp;</td>
			<td align=left width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;⚡ &nbsp;Watt Level</div></td>
			<td align=right width=50px valign=bottom> <div class="vitals3 text-glow" style="white-space: nowrap;"> <b>{ mebots[mebot_i].watt_level }</b></div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px valign=bottom>
			<td width=55px>&nbsp;</td>
			<td align=left> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;🎮 &nbsp;Experience </div></td>
			<td align=right width=50px valign=bottom> <div class="vitals2 text-glow" style="white-space: nowrap;"> { numberWithCommas(mebots[mebot_i].experience) } </div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px valign=bottom>
			<td width=55px>&nbsp;</td>
			<td align=left> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;〰️ &nbsp;Class </div></td>
			<td align=right width=50px valign=bottom> <div class="vitals2 text-glow" style="white-space: nowrap;"> { numberWithCommas(mebots[mebot_i].class) } </div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left>
			<div class="vitals2 text-glow" style="white-space: nowrap;">
				{#if mebots[mebot_i].is_owner == 1 }
				&nbsp;👑&nbsp; Owner
				{/if}
			</div></td>
			<td align=right width=50px> <div class="vitals2 text-glow" style="white-space: nowrap;"> &nbsp; </div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=10px>
		</tr>
	</table>
	{:else}
    <div class="snake_row">
        {#each mebots as mebot, i}
            <div class="flip-box" >

                <div class="flip-box-inner">
                    <div class="flip-box-front card">
						<a href="/#/stats/{dash_token}/{mebot_id}/{mebots[i].id}">
                        <div class="vertical-center" on:click={displayMebotDetails}>
							    <div class="message question no_tap_zoom" transition:fade|local={{duration: 300}} on:click={ doNothing }> <img on:click={ doNothing } class="no_tap_zoom" src="{mebot.mebot_img_url}" data-card-id={i} class:mebot_active1={ mebot.is_owner == 1 } width=100px alt="mebot"></div>
							    <!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
                        </div>
						</a>
                    </div>
                </div>

            </div>
        {/each}
    </div>
	{#if byline != '' }
	<div class="snake_row">
			<div class="vitals2 text-glow-electric" style="white-space: nowrap;" >
			{#if type_id == 6 }
				Invited: {invite_count} &nbsp; <span style="color: grey;">|</span> &nbsp;
			{/if}
			{@html byline}
		</div>
	</div>
	{/if}
	{#if social_link != ''}
	<center>
	<table border=0 cellpadding=0 cellspacing=0 width=240>
		<tr>
		<td width=160>
			<div class="vitals2 text-glow-electric" style="white-space: nowrap;">
				Invite 👭
				<input size="18" type="text" id="social_link" bind:value={social_link} disabled>
			</div>
		</td>
		<td width=80>
			<button class="tooltip" class:copy-pulsing={ copied } on:click={ copySocial } style="white-space: nowrap;"> ⇧ Share </button>
		</td>
		</tr>
		<tr height=10px>
			<td colspan=2>
			<span style="display: flex; align-items:center;" >
				<span class="vitals2 text-glow-electric" style="white-space: nowrap;">
					Invite Bounty:
				</span>
				<span class="text-electric-white" style="display: flex; align-items:center;" >

					{#if invite_bounty == 0 }
					<span class="vitals2 text-glow-electric" style=" font-size: 13px;">&nbsp; Get </span>
					{/if}

					<span class="text-electric" style="color:silver; margin-top: 4px;" >
						<span class="text-electric-yellow" style="font-size:0;">
							<img src='/img/sparkle-zm1.png' width=24px height=24px alt='sparkle'>
						</span>
					</span>

					{#if invite_bounty == 0 }
					<span class="vitals2 text-glow-electric" style=" font-size: 13px;"> 1,000 per invite</span>
					{:else}
					<span class="vitals2 text-glow-electric" style=" font-size: 13px;"> { numberWithCommas(invite_bounty) } earned</span>
					{/if}
				</span>
			</span>
		</td></tr>
	</table>
	</center>
	{/if}
	{/if}

	<div class="small_row">
	</div>

</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={true}
		closeOnOuterClick={false}
		>
</Modal>

<style>

	.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9), 0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
	}
	
	.snake_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom: 10px;
		margin-left: 40px;
		margin-right: 30px;
	}

	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		width: 100px;
		height: 100px;
		margin: 0 2px 24px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
	}

	/* Position the front and back side */
	.flip-box-front, .flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 56%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .message {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

	img {
		max-height: 90%;
	}

	.card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.text-glow {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: white;
	}

	.text-glow-electric {
		text-shadow: 0 0 10px rgba(64, 255, 249, 0.75),
			0 0 32px rgba(65, 246, 255, 0.88);
		font-family: arial;
		color: rgb(156, 255, 250);
	}

	.vitals2-grey {
		color: rgb(242, 248, 247);
		font-size: 14px;
	}

	.vitals2 {
		color: white;
		font-size: 14px;
	}
	.vitals3 {
		color: white;
		font-size: 15px;
	}

	.controls {
		margin-bottom: 15px;
	}

	.mebot_active1 {
        border-radius: 15px;
        box-shadow: 0 3px 7px rgb(231, 247, 255);

        background: linear-gradient(114deg, #ffffff, #725cd8, #42e3ff, #42e3ff);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 6s ease infinite;
		-moz-animation: AnimationName 6s ease infinite;
		-o-animation: AnimationName 6s ease infinite;
		animation: AnimationName 6s ease infinite;
	}

    @-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	.no_tap_zoom {
		touch-action: manipulation;
	}

	.like-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.5s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.hand-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.4s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.copy-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.3s;
	}

	input[type="text"] {
		background: rgba(0, 0, 0, 0);
		border: none;
		outline: none;
		color: white;
		font-size: 10px;
	}

	.tooltip {
		margin-top: 0px;
		font-size: 12px;
		border-radius: 6px;
		border: 1px solid rgb(83, 83, 83);
		background-color: transparent;
		color: #1bffe8ee;
		padding: 3px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

</style>